module.exports = __webpack_public_path__ + "images/emoji/clipboard.d7df4562fd315b13d7c1.png";